import { render, staticRenderFns } from "./InteractionStatistics.vue?vue&type=template&id=52dd0398&"
import script from "./InteractionStatistics.vue?vue&type=script&lang=js&"
export * from "./InteractionStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports